import { gql } from "@apollo/client";

export const cameraByHardwareInfoQuery = gql`
    query CameraByHardwareInfoAdmin($sn: String!, $msisdn: String!) {
        cameraByHardwareInfoAdmin(sn: $sn, msisdn: $msisdn) {
            id
            hardwareInfo {
                sn
                msisdn
            }
        }
    }
`;

export const updateLicenceCameraQuery = gql`
    mutation UpdateLicenceCamera($id: ID!, $input: UpdateLicenceCameraInput!) {
        updateLicenceCamera(id: $id, input: $input) {
            id
        }
    }
`;
